import i18n from "../i18n";

/**
 * Resolves a backend API error response to a translated string.
 * Tries to translate data.code via i18n; falls back to data.message or data.error.
 */
export const resolveApiMessage = (data, fallback = "") => {
  if (data?.code) {
    const translated = i18n.t(data.code);
    if (translated !== data.code) return translated;
  }
  return data?.message || data?.error || fallback;
};
